import { LexicalComposer } from '@lexical/react/LexicalComposer';
import cx from 'classnames';
import { ContentEditable, LexicalErrorBoundary } from './components';
import { initialConfig } from './constants';
import {
  HistoryPlugin,
  RichTextPlugin,
  ToolbarPlugin,
  TabIndentationPlugin,
  InitialHtmlContentPlugin,
  OnChangePlugin,
  DisabledPlugin,
} from './plugins';
import { extendListItemNode, extendParagraphNode, extendTextNode } from './utils';

import './styles.css';

extendListItemNode();
extendTextNode();
extendParagraphNode();

type EditorProps = {
  disabled?: boolean;
  initialHtmlContent?: string;
  onChange?: (htmlString: string) => void;
  testId?: string;
};

export const Editor = ({ disabled = false, initialHtmlContent, onChange, testId }: EditorProps) => {
  return (
    <LexicalComposer initialConfig={initialConfig}>
      <div
        className={cx(
          'border-solid border-[#eee] rounded-[10px] border-2 outline-none relative bg-white',
          disabled && 'cursor-not-allowed',
        )}
        data-testid={testId}
      >
        <ToolbarPlugin disabled={disabled} />
        {typeof initialHtmlContent === 'string' && (
          <InitialHtmlContentPlugin initialHtmlContent={initialHtmlContent} />
        )}

        <RichTextPlugin
          contentEditable={<ContentEditable />}
          ErrorBoundary={LexicalErrorBoundary}
        />
        <HistoryPlugin />
        <TabIndentationPlugin />
        {onChange && <OnChangePlugin onChange={onChange} />}
        <DisabledPlugin disabled={disabled} />
      </div>
    </LexicalComposer>
  );
};
